<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-module-submodule-select
              ref="selectModule"
              :pageId="this.$options.name"
              :selectedMd="searchFrame.selectedCodeValue.moduleCode"
              :selectedSmd="searchFrame.selectedCodeValue.subModuleCode"
              :defaultSmdOption="'all'"
              class="dp_flex"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TYPE')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="selectDataServiceTypeCode"
              :selected="searchFrame.selectedCodeValue.dataServiceTypeCode"
              :pageId="this.$options.name"
              codeId="COD_DTSVC_TYPE"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="selectDataServiceSearchCond"
              :selected="searchFrame.selectedCodeValue.dataServiceSearchCond"
              :pageId="this.$options.name"
              codeId="COD_DTSVC_SEARCH_COND"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
              style="width:71.5%"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model="searchFrame.dataServiceSearchWord"
              maxlength="50"
              @keyup="onKeyUpInput"
              @keyup.enter="onSearchClick"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            v-permission:read="this.$options.name"
            type="button"
            class="comm_btn_Reset"
            @click="onResetClick"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="this.$options.name"
            type="button"
            class="comm_btn_Scr"
            @click="onSearchClick"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="listGrid"
        :dataset="'ds0'"
        :columns="gridColumns"
        :multiselect="multiSelect"
        :showDisplayCountControl="false"
      />
    </sui-page-contents>
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <sui-button
          v-permission:read="this.$options.name"
          type="button"
          class="comm_btn_border"
          @click="onCancelClick"
        >
          {{ this.$t('MSG_BTN_CANCEL') }}
        </sui-button>
        <sui-button
          v-permission:update="this.$options.name"
          type="button"
          class="comm_btn_solid"
          @click="onSelectClick"
        >
          {{ this.$t('MSG_TXT_SEL') }}
        </sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>
<script>
// import - libraries (node modules)
// import - local files (js, vue, ...)
// 페이지 에서 사용하는 code 목록 기술
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMU_00005', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default: () => {},
    },
    pageInitialData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      searchFrame: {
        selectedCodeValue: {
          moduleCode: {
            label: '',
            key: '',
          },
          subModuleCode: {
            label: '',
            key: '',
          },
          dataServiceTypeCode: {
            label: '',
            key: '',
          },
          dataServiceSearchCond: {
            label: '',
            key: '',
          },
        },
        dataServiceSearchWord: '',
      },
      localdata0: [],
      gridColumns: [{
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleName',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModuleName',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_DTSVC_ID'),
        datafield: 'dataServiceIdentification',
        width: '150px',
      }, {
        text: this.$t('MSG_TXT_DTSVC_NM'),
        datafield: 'dataServiceName',
      }, {
        text: this.$t('MSG_TXT_TYPE'),
        datafield: 'dataServiceTypeName',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_DTSVC_URL'),
        datafield: 'dataServiceUniformresourcelocator',
      }, {
        text: this.$t('MSG_TXT_PRMSN'),
        datafield: 'dataServicePermissionName',
        width: '100px',
      }],
      searchFieldOldText: '',
      multiSelect: false,
    };
  },
  datasets: [{
    id: 'ds0',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'moduleCode', map: 'moduleCode' },
      { type: 'string', name: 'moduleName', map: 'moduleName' },
      { type: 'string', name: 'subModuleCode', map: 'subModuleCode' },
      { type: 'string', name: 'subModuleName', map: 'subModuleName' },
      { type: 'string', name: 'dataServiceName', map: 'dataServiceName' },
      { type: 'string', name: 'pageMetaBasicYn', map: 'pageMetaBasicYn' },
      { type: 'string', name: 'dataServiceCntn', map: 'dataServiceCntn' },
      { type: 'string', name: 'dataServiceUseYn', map: 'dataServiceUseYn' },
      { type: 'string', name: 'dataServiceTypeCode', map: 'dataServiceTypeCode' },
      { type: 'string', name: 'dataServiceTypeName', map: 'dataServiceTypeName' },
      { type: 'string', name: 'dataServiceBlockCntn', map: 'dataServiceBlockCntn' },
      { type: 'string', name: 'dataServiceStateCode', map: 'dataServiceStateCode' },
      { type: 'string', name: 'dataServiceStateName', map: 'dataServiceStateName' },
      { type: 'string', name: 'firstRegistrationDTM', map: 'firstRegistrationDTM' },
      { type: 'string', name: 'finalModificationDTM', map: 'finalModificationDTM' },
      { type: 'string', name: 'firstRegistrationUserId', map: 'firstRegistrationUserId' },
      { type: 'string', name: 'finalModificationUserId', map: 'finalModificationUserId' },
      { type: 'string', name: 'dataServiceIdentification', map: 'dataServiceIdentification' },
      { type: 'string', name: 'dataServicePermissionCode', map: 'dataServicePermissionCode' },
      { type: 'string', name: 'dataServicePermissionName', map: 'dataServicePermissionName' },
      { type: 'string', name: 'firstRegistrationProgramId', map: 'firstRegistrationProgramId' },
      { type: 'string', name: 'finalModificationProgramId', map: 'finalModificationProgramId' },
      { type: 'string', name: 'dataServiceUniformresourcelocator', map: 'dataServiceUniformresourcelocator' },
    ],
  }],
  mounted() {
    this.multiSelect = this.pageInitialData.multiSelect;
  },
  methods: {
    // _ 제외 특수문자 입력제한
    onKeyUpInput() {
      const searchFieldNewText = this.searchFrame.dataServiceSearchWord;

      if (utils.isExistSpecialChar(searchFieldNewText)) {
        utils.messageBox('warning', this.$t('MSG_ALT_NO_SPECL_CHAR'), null, () => {
          this.searchFrame.dataServiceSearchWord = this.searchFieldOldText;
        });
      } else {
        this.searchFieldOldText = searchFieldNewText;
      }
    },
    onResetClick() {
      this.searchFrame.dataServiceSearchWord = '';
      utils.forEach(this.$refs, (ref, key) => {
        if (utils.startsWith(key, 'select')) {
          if (utils.isEqual(key, 'selectModule')) {
            ref.selectMd('CM');
          } else {
            ref.reset();
          }
        }
      });
    },
    getSearchData() {
      const data = {};
      utils.forEach(this.searchFrame, (value, key) => {
        if (utils.isEqual(key, 'selectedCodeValue')) {
          utils.forEach(value, (codeValue, codekey) => {
            data[codekey] = codeValue.key;
          });
        } else {
          data[key] = value;
        }
      });
      return data;
    },
    onSearchClick() {
      const queryParams = this.getSearchData();
      http.request(this.$options.name, 'DTS_CMU_00007', {
        query: queryParams,
      }).then(res => {
        this.ds0.setRawData(res.data);
        this.ds0.setSelectedIndexes([]);
      }).catch(error => {
        console.log(error);
      });
    },
    onSelectClick() {
      const selectedData = this.ds0.getSelectedRawData();
      if (selectedData.length !== 0) {
        this.closePagePopup(selectedData);
      } else {
        // 선택 안했을 때
        //utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_DTSVC')));
        utils.messageBox('alert', null, this.$t('MSG_ALT_NOT_SEL_ITEM'));
      }
    },
    onCancelClick() {
      this.closePagePopup();
    },
  },
};
</script>
<style scoped>
</style>
